export default __webpack_public_path__ + "static/media/Livelihood-zoning.68f3726b.md";